import styled from "styled-components";

export const Separator = styled.hr`
  border: 1px solid #f0f3f6;
  margin: 32px 0;
`;
